import messages from "../../messages";
import { VALID_EMAIL_REGEX } from "../../../data/constants";

export const emailRegex = new RegExp(VALID_EMAIL_REGEX, "i");

export const validateAlternativeEmail = (value, formatMessage) => {
  if (!value || value.trim() === "") {
    return "";
  }
  if (!emailRegex.test(value)) {
    return formatMessage(messages["alternate_email.invalid.format.error"]);
  }
  return "";
};

export const validateCompany = (value, formatMessage) => {
  if (!value || value.trim() === "") {
    return formatMessage(messages["empty.company.field.error"]);
  }
  return "";
};

export const validatePhoneNumber = (value, formatMessage) => {
  if (!value || value.trim() === "") {
    return formatMessage(messages["empty.phone_number.field.error"]);
  }
  return "";
};
